
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ConfirmDialog extends Vue {
  @Prop()
  show!: boolean;

  @Prop({ default: "info" })
  type: "success" | "warning" | "error" | "info" | undefined;

  @Prop({ default: false })
  hasCancel!: boolean;

  @Prop({ default: "Cancel" })
  cancelText!: string | undefined;

  @Prop()
  saveIsEnabled!: boolean;

  @Prop()
  saveIsInProgress!: boolean;

  @Prop({ default: true })
  hasDiscard!: boolean;

  @Prop()
  discardIsEnabled!: boolean;

  @Prop()
  discardIsInProgress!: boolean;

  @Prop({ default: "Save" })
  actionText!: string | undefined;

  @Prop({ default: "Discard" })
  discardText!: string | undefined;
}
